import 'bootstrap/dist/css/bootstrap.min.css';
import styled from 'styled-components';
import React, { useState } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { ChevronRight } from 'react-bootstrap-icons';
import { Link } from 'gatsby';
import ImageComponent from '../../utils/imageComponent';
import ButtonComponent from '../../utils/ButtonComponent';
import LinkComponent from '../../utils/linkComponent';
// import ColorThief from 'color-thief';

const TopBannerStyled = styled.div`
	.bannerContent {
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: start;
		height: 100%;
		margin-left: 3em;
	}

	.description {
		font-weight: 300;
		font-size: 1.5em;
		font-size: var(--font-size-md);
		margin-bottom: 1em;
		line-height: 1.5em;
		text-align: center;
	}

	h1 {
		color: var(--primary);
		font-weight: 700;
		/* font-size: 2.5rem; */
		font-size: var(--font-size-xl);
		text-align: center;
	}

	.connect {
		text-align: right;
		margin-top: 1rem;
		margin-bottom: 1rem;
	}

	.banner {
		width: 25em;
	}

	.fullBanner {
		width: 100%;
	}

	.bg {
		width: 9em;
	}

	.bannerCol {
		padding: 0;
	}

	.bannerColRight {
		justify-content: end !important;
	}
	.btnContainer {
		margin-top: 2rem;
		margin-bottom: 0.5em;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	@media (max-width: 768px) {
		.bannerContent {
			padding: 1em;
			margin: 0;
			align-items: center;
			text-align: center;
		}

		.description {
			margin-bottom: 0em;
		}
		h1 {
			font-size: 2rem;
		}

		.bg {
			display: none;
		}

		.connect {
			text-align: left;
			margin-top: 1rem;
			margin-bottom: 1rem;
		}
		.banner {
			width: 18em;
		}
	}
`;
const TopBanner = (props) => {
	const { content, title, strapiAsset } = props;
	const { design_options } = content.content ? content.content : '';
	const [bannerContrastTextColor, setBannerContrastTextColor] =
		useState('white');

	//useEffect to set the bannerContrastTextColor
	React.useEffect(() => {
		if (design_options) {
			if (design_options && design_options.background_colour) {
				// background color is used
				const styles = getComputedStyle(
					document?.getElementById('layoutStyled')
				);
				setBannerContrastTextColor(
					getContrastYIQ(
						styles.getPropertyValue(`--${design_options.background_colour}`)
					)
				);
				// console.log('bannerContrastTextColor', bannerContrastTextColor);
			} else if (design_options?.background_image) {
				// background image is used
				setBannerContrastTextColor(
					getContrastYIQFromImage(design_options?.background_image?.url)
				);
				// console.log('bannerContrastTextColor', bannerContrastTextColor);
			}
		}
	}, [design_options, bannerContrastTextColor]);

	// get the contrast font color based on the background hex code
	const getContrastYIQ = (hexcolor) => {
		hexcolor = hexcolor.replace('#', '');
		var r = parseInt(hexcolor.substr(0, 2), 16);
		var g = parseInt(hexcolor.substr(2, 2), 16);
		var b = parseInt(hexcolor.substr(4, 2), 16);
		var yiq = (r * 299 + g * 587 + b * 114) / 1000;
		return yiq >= 128 ? 'var(--dark_overlay)' : 'var(--light_overlay)';
	};

	// get the contrast font color based on the background image
	const getContrastYIQFromImage = (image) => {
		// var colorThief = new ColorThief();
		// var color = colorThief.getColor(image);
		// var r = color[0];
		// var g = color[1];
		// var b = color[2];
		// var yiq = (r * 299 + g * 587 + b * 114) / 1000;
		// return yiq >= 128 ? 'black' : 'white';
	};

	return (
		<TopBannerStyled>
			{content.only_image ? (
				<Col xs={12} md={12} lg={12} className='row g-0'>
					{content.image && (
						<ImageComponent
							imageItem={content.image}
							className='fullBanner'
						></ImageComponent>
					)}
				</Col>
			) : (
				<Row
					style={
						design_options?.background_image?.url
							? //use the image
							  {
									backgroundImage: `url(${design_options?.background_image?.url})`,
							  }
							: //use the background colour
							  {
									backgroundColor: `var(--${design_options?.background_colour})`,
							  }
					}
				>
					<>
						{content.content.image_side === 'left' && (
							<Col xs={12} md={6} lg={5} className='bannerCol'>
								{content.image && (
									<ImageComponent
										imageItem={content.image}
										className='banner'
									></ImageComponent>
								)}
							</Col>
						)}
						<Col xs={12} md={6} lg={7}>
							<div className='bannerContent'>
								<div>
									<h1
										style={
											// get the contrast font color based on the hex code
											design_options?.text_align === 'left'
												? {
														color: bannerContrastTextColor,
														textAlign: 'left',
												  }
												: {
														textAlign: 'center',
														color: bannerContrastTextColor,
												  }
										}
									>
										{content.content.title !== null
											? content.content.title
											: ''}
									</h1>
								</div>
								<div
									style={
										design_options?.text_align === 'left'
											? { color: bannerContrastTextColor, textAlign: 'left' }
											: {
													color: bannerContrastTextColor,
													textAlign: 'center',
											  }
									}
									className='description'
								>
									{content.content.caption}
								</div>
								{content.content.button !== null && (
									<div className='btnContainer'>
										<LinkComponent
											to={
												content.content.button?.link !== null
													? content.content.button?.link
													: ''
											}
										>
											<ButtonComponent
												analyticsTrackTitle={title}
												analyticsTitle={`Top Banner Panel - ${
													content.quick_links !== null
														? content.quick_links?.short_title
														: ''
												}`}
												windowLocationHref={
													typeof window !== 'undefined' && window.location.href
												}
												buttonName={
													content.content.button !== null
														? content.content.button?.name
														: ''
												}
												iconVisible={true}
												buttonShape={strapiAsset?.button_shape}
											></ButtonComponent>
										</LinkComponent>
									</div>
								)}
							</div>
						</Col>
						{content.content.image_side === 'right' && (
							<Col xs={12} md={6} lg={5} className='bannerCol bannerColRight'>
								<div style={{ float: 'right' }}>
									{content.image && (
										<ImageComponent
											imageItem={content.image}
											className='banner'
										></ImageComponent>
									)}
								</div>
							</Col>
						)}
					</>
				</Row>
			)}
		</TopBannerStyled>
	);
};
export default TopBanner;
